import LeagueLeaderboardMetaModel from "../Meta/LeagueLeaderboardMetaModel";
import LeaderboardModel from "./LeaderboardModel";

export default class LeaderboardLeagueResponse {
  public meta: LeagueLeaderboardMetaModel = new LeagueLeaderboardMetaModel();
  public data: LeaderboardModel[] = [];
}
